<template>
  <div class="site-categories">
    <translate tag="p" v-if="showTitle"> Site type </translate>

    <div class="category-icons horizontal-spacing">
      <div
        v-for="siteType in siteTypesFiltered"
        :key="siteType.id"
        class="site-category"
      >
        <img
          loading="lazy"
          :src="getIconForSiteType(siteType)"
          :class="['category-icon', siteType.slug]"
          :alt="siteType.name"
          width="20"
          height="20"
        />
        <span class="count">{{ siteType.pitchTypesCount }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { SiteType } from '../../../campsite-details/types'
import {
  Component,
  Prop,
  Setup,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'
import { getCampsiteCategoriesPresenter } from '~/apps/categories/presenter-json/CampsiteCategoriesUpdaterJson'

@Component
class SiteTypes extends Vue {
  @Prop({ required: true })
  siteTypes: SiteType[]

  @Prop({ default: true })
  showTitle: boolean

  @Setup(() => {
    const route = useRoute()
    return getCampsiteCategoriesPresenter(
      (route.params.lang as string) || 'en-gb',
    )
  })
  categoriesPresenter: ReturnType<typeof getCampsiteCategoriesPresenter>

  get siteTypesFiltered(): SiteType[] {
    return this.siteTypes
      .filter((siteType) => siteType.pitchTypesCount > 0)
      .filter((siteType) => this.isRootSite(siteType))
  }

  getIconForSiteType(siteType: SiteType): string {
    // https://www.lichter.io/articles/nuxt3-vue3-dynamic-images/#the-importmetaglob-trick
    const glob = import.meta.glob('@/assets/images/category-icons/*.svg', {
      query: '?url',
      eager: true,
    })
    return glob[`/assets/images/category-icons/${siteType.slug}.svg`].default
  }

  isRootSite(siteType: SiteType) {
    const categoriesPresenter = getCampsiteCategoriesPresenter(
      this.$route.params.lang || 'en-gb',
    )
    return !!categoriesPresenter.bySlugMap[siteType.slug]
  }
}

export default toNative(SiteTypes)
</script>

<style scoped>
.site-categories p {
  font-size: var(--body);
  color: var(--colour-text-default);
}

.site-category {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0.5em;
  flex-shrink: 0;
}

.category-icons {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0.25em 0 0;
  flex-wrap: wrap;
}

.category-icon {
  width: 1.5em;
  height: 1.25em;
  vertical-align: bottom;
}

.count {
  font-size: var(--small);
  text-align: center;
  color: var(--colour-text-light);
  margin-bottom: 0.25em;
}
</style>
